<template>
  <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link id="brand" class="navbar-item" to="/">
          <img width="48" height="48" src="/static/logo-64.png"><h2><strong>PixxiBook</strong></h2>
      </router-link>
      <div class="navbar-burger burger" :class="{'is-active': navIsActive}"
           data-target="navMenu"
           @click="toggleMenu">
        <span></span> <span></span> <span></span>
      </div>
    </div>
    <div id="navMenu" class="navbar-menu" :class="{'is-active': navIsActive}">
      <div class="navbar-start">
        <router-link class="navbar-item" to="/doc/formats">Books</router-link>
        <router-link class="navbar-item" to="/doc/pricing">Pricing</router-link>
        <router-link class="navbar-item" to="/gallery">Gallery</router-link>
        <b-dropdown class="navbar-item" hoverable>
          <a slot="trigger">
            <span>Support</span>
            <b-icon icon="menu-down"></b-icon>
          </a>
          <b-dropdown-item has-link>
            <router-link class="navbar-item" to="/doc/delivery">
              <span><b-icon icon="truck-delivery"></b-icon>
                Delivery</span></router-link>
          </b-dropdown-item>
          <b-dropdown-item has-link>
            <router-link class="navbar-item" to="/doc/faq">
              <b-icon icon="help-circle-outline"></b-icon> Frequently Asked Questions </router-link>
          </b-dropdown-item>
          <b-dropdown-item has-link>
            <router-link class="navbar-item" to="/doc/about#contact">
              <b-icon icon="message-outline"></b-icon> Contact Us </router-link>
          </b-dropdown-item>
          <b-dropdown-item has-link>
            <router-link class="navbar-item" to="/doc/about">
              <b-icon icon="lightbulb-on-outline"></b-icon> About PixxiBook </router-link>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="navbar-end">
        <router-link class="navbar-item" v-if="isSignedIn"
                     to="/mybooks"><b-icon icon="book-open-variant"/>&nbsp;My Books</router-link>
        <router-link class="navbar-item" v-if="cartItemCount"
                     to="/checkout"><b-icon icon="cart"/>&nbsp;Cart [{{cartItemCount}}]
        </router-link>
        <div id="sign-in" v-if="!user || !isSignedIn"
             class="is-primary navbar-item has-link>">
          <a @click="showSignup=true">Sign Up/In</a>
        </div>
        
        <b-dropdown v-else position="is-bottom-left" class="navbar-item" hoverable>
          <a slot="trigger">
            <b-icon icon="account"></b-icon>
            <b-icon icon="menu-down"></b-icon>
          </a>

          <b-dropdown-item class="is-active">
            <span id="user-email">{{user.email}}</span>
          </b-dropdown-item>

          <!-- custom: the currency <select> is interactive, so this item must not
               behave as a menu choice - without it, clicking the select fires
               selectItem() which closes the menu and clears isHoverable -->
          <b-dropdown-item custom class="level">
            <span class="level-left">Prices in:</span><currency-selector class="level-right"/>
          </b-dropdown-item>

          <hr class="dropdown-divider">
           
          <b-dropdown-item has-link>
            <router-link class="navbar-item support" to="/dashboard"
                         v-if="isSupport">
              <b-icon icon="finance"></b-icon>
              Admin Dashboard
            </router-link>
          </b-dropdown-item>

          <b-dropdown-item has-link>
            <router-link class="navbar-item support" to="/myaccount"
                         v-if="isSupport">
              <b-icon icon="account"></b-icon>
              My Account
            </router-link>
          </b-dropdown-item>

          <!--b-dropdown-item has-link>
            <router-link class="navbar-item" to="/mybooks">
              <b-icon icon="settings-outline"></b-icon>
              Profile
            </router-link>
          </b-dropdown-item-->

          <b-dropdown-item id="sign-out" @click="signout">
            <b-icon icon="logout"></b-icon>
            Sign Out
          </b-dropdown-item>
        </b-dropdown>

      </div>
    </div>

    <b-modal v-if="!isSignedIn" :active.sync="showSignup" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Sign up or sign in...</p>
        </header>
    
        <section class="modal-card-body">
          <signup-card message="An account is optional but it means you
          will always be able to get back to your book later and to follow up
          on your orders. In addition, we can keep you up to date with new
          features. We will not share your address with anyone except
          where it is necessary for payments or delivery."></signup-card>
        </section>
        
        <footer class="modal-card-foot">
        </footer>
      </div>
    </b-modal>
    
    <!--div class="banner" v-if="showBanner">
      <router-link to="/doc/formats#video"><h1 @click="showBanner=false">NEW! Video Tour</h1></router-link>
    </div-->
    
  </nav>
</template>

<script>
import SignupCard from '@/components/SignupCard'
import CurrencySelector from '@/components/CurrencySelector'
import Firebase from '../firebase.js'

export default {
  name: 'NavBar',
  components: {
    SignupCard,
    CurrencySelector,
  },
  data () {
    return {
      showSignup: false,
      navIsActive: false,
      showBanner: true,
    }
  },
  computed: {
    user: function() { return this.$store.state.user },
    cartItemCount: function() { return this.$store.state.cart.itemCount },
    isSignedIn: function() {
      return this.$store.state.isSignedIn
    },
    isSupport: function() {
      return this.user.email && this.user.email.includes('pixxibook')
    },
  },
  watch: {
    user: function(newUser) {
      if (newUser && !newUser.isAnonymous) {
        this.showSignup = false
      }
    },
  },
  methods: {
    toggleMenu: function() {
      this.navIsActive = !this.navIsActive
    },
    signout: function() {
      console.log("sign out user")
      Firebase.auth.signInAnonymously()
    },
  },
}
</script>

<style>
@media screen and (min-width: 1200px) {
  .banner {
      font-size: 36px !important;
  }
}
</style>

<style scoped>
#navMenu {
    background-color: #363636;
}
#brand {
    padding: 0 1em 0 1em;
}
#brand h2 {
}
#brand img {
    max-height: 48px; 
    padding-bottom: 0ex;
}
.navbar-item { font-size: 120%; }
nav.is-dark a { color: white; }
nav.is-dark .dropdown-content a { color: black; }
nav.is-dark .dropdown-item.is-active { background-color: inherit; }

.banner {
    position: absolute;
    font-size: 3vw;
    top: -3em;
    right: -7em;
    background-color: #ff3860;
    color: white;
    border-top: .2rem solid white;
    border-bottom: .2rem solid white;
    outline: .2rem solid #ff3860;
    transform: rotate(45deg);
    transform-origin: top left;
    padding: 0 5em 0 5em;
    opacity: 0.7;
    z-index: 100;
}
.no-click {
    pointer-events: none;
}

.support .icon {
    background: #ffdd57;
}

.navbar-item .xmas  {
    position: relative;
    background: green;
    border: 0.5ex solid green;
    border-radius: 0.5ex;
    padding: 0 1ex;
    overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue